var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../user');
require('../lr-touch');
require('../thankyou-modal');
require('../error-modal');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$addEmailModal', [
    '$log',
    '$location',
    '$user',
    '$uibModal',
    '$timeout',
    '$thankyouModal',
    '$errorModal',
    '$fsloading',

    function $addEmailModalService($log, $location, $user, $uibModal, $timeout, $thankyouModal, $errorModal, $fsloading) {
        /*
        @function openFirstFilterModal
        */
        return function openAddEmailModal() {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: ['$scope', function addEmailModalCtrl($scope) {

                    var saveEmail = function (str) {
                        if(str && str.length > 0) {
                            $fsloading.show();
                            $user.email = str;
                            $user.save()
                                .then(function (response) {
                                    return $user.sendEmailVerification($location.absUrl());
                                })
                                .then(function (response) {
                                    $thankyouModal('We\'ve sent a verification email to the address you\'ve provided. Once you confirm, your notification settings will be set.');
                                    $scope.$close(response);
                                })
                                .catch(function (err) {
                                    $log.error('Something went wrong while trying to save email: ', err);
                                    $errorModal();
                                    $scope.$dismiss(err);
                                })
                                .finally(function () {
                                    $fsloading.hide();
                                });
                        }
                    };

                    var initUserObj = function () {
                        $scope.usr = JSON.parse(JSON.stringify($user));
                    };

                    var init = function () {
                        initUserObj();
                    };

                    init();


                    /// PUBLIC API

                    $scope.submitEmail = function () {
                        $log.debug('Saving Email!', $scope.usr.email);
                        saveEmail($scope.usr.email);
                    };

                }],
                backdrop: true,
                windowClass: 'add-email-modal'
            });

            return modal.result;
        };
    }
]);
